export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          移动观影
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          下载白云视频APP，随时随地免费看高清影视
        </p>
        <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20mockup%20displaying%20video%20streaming%20app%20interface%20with%20movie%20posters%20and%20play%20buttons%2C%20warm%20orange%20accent%20colors%2C%20clean%20minimal%20UI%20design%2C%20smartphone%20screen%20mockup%2C%20professional%20app%20presentation%2C%20soft%20lighting%2C%20Chinese%20text%20elements&width=400&height=700&seq=app-mockup-01&orientation=portrait"
                alt="白云视频APP手机端界面展示"
                className="w-48 h-auto rounded-2xl"
              />
            </div>
            <div className="flex-1">
              <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-3">
                白云视频APP — 口袋里的免费影院
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                专为移动观影打造的APP体验，支持离线缓存、投屏播放、画质切换等实用功能。打开APP即可畅享30000+影视资源，西瓜视频同类型高清体验尽在掌握。无论是通勤路上、午休时间还是睡前放松，白云视频APP都是您最贴心的免费影视伴侣。
              </p>
              <div className="flex flex-wrap gap-4 text-xs text-foreground-500 mb-5">
                <div className="flex items-center gap-1.5">
                  <i className="ri-download-2-line text-primary-500 text-base"></i>
                  离线缓存随时看
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-cast-line text-primary-500 text-base"></i>
                  一键投屏大屏看
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-notification-3-line text-primary-500 text-base"></i>
                  新片上线提醒
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="#"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  App Store 下载
                </a>
                <a
                  href="#"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}